import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

/**
 * Function wraps all newlines in element with provided tags
 * @param e - target element
 * @param t - content to prepend
 * @param o - content to append
 */
function splitLines (e, t, o) {
  var n = 0, r = '', a = !0
  e.innerHTML = e.innerHTML.replace(/(<font[^>]+>|<font>|<\/font>)/g,
    ''), e.innerHTML = e.innerHTML.replace(/\S+/g, '<n>$&</n>')
  for (let c = e.children, i = 0; i < c.length; i++) {
    var l = c[i].getBoundingClientRect().top
    n < l && (a ? (r += t, a = !1) : r += o + t), n = l, r += c[i].textContent +
      ' '
  }
  e.innerHTML = r += o
}

/**
 * Split each text block in spans, for animation
 */
function splitTextIntoChunks () {
  gsap.utils.toArray('.to-split').forEach(e => {
    let divs = e.querySelectorAll('h2'), i;

    for (i = 0; i < divs.length; ++i) {
      splitLines(divs[i], '<span class="line-container"><span>', '</span></span>')
    }

    let fadeDivs = e.querySelectorAll('h3, h4, h5, h6, p, strong, b, li, blockquote'), j;
    for (j = 0; j < fadeDivs.length; ++j) {
      $(fadeDivs[j]).addClass('line-container-fade')
    }
  })
}

/**
 * Animate text show-up
 */
function setUpTextAnimation () {
  $('.line-container-fade').css('opacity', 0)
  gsap.utils.toArray('.scroll-trigger').forEach(element => {
    function introSplitText () {

      if(element.querySelectorAll('.line-container span').length) {
        gsap.to(element.querySelectorAll('.line-container span'), {
          y: '0%',
          ease: Power4.easeOut,
          stagger: .08,
          duration: 1,
          delay: 0
        })
      }

      if(element.querySelectorAll('.line-container-fade').length) {
        gsap.to(element.querySelectorAll('.line-container-fade'), {
          opacity: 1,
          ease: Power4.easeOut,
          //stagger: .08,
          duration: 1,
          delay: 0.2
        })
      }

    }

    ScrollTrigger.create({
      trigger: element,
      start: 'top 70%',
      end: 'bottom 30%',
      scrub: true,
      //markers: true,
      onEnter: introSplitText
    })
  })
}

export { splitTextIntoChunks, setUpTextAnimation }
